<template>
  <aside class="Panel PanelEmail">
    <transition name="fade" appear v-if="data"><div class="Panel_cache" @click="closePanel"></div></transition>
    
    <transition name="fade" appear>
      <button class="Panel_close" @click="closePanel" v-if="data"><i class="fal fa-times"></i></button>
    </transition>

    <transition name="panel" appear>
      <div class="Panel_wrapper" v-if="data" ref="wrapper">

        <transition name="fade">

          <div class="Panel_content Panel_intro" v-if="emailOk" key="ok">

            <Media :data="data.illustration" />
            <h3>Merci !</h3>
            <p>Un email récapitulatif vient de vous être envoyé.</p>

          </div>

          <div class="Panel_content Panel_intro" v-else key="base">
            <h3 v-html="data.title"></h3>
            <p v-html="data.content" v-if="data.content"></p>

            <Media :data="data.illustration" />

            <h4>Je reçois un récapitulatif par e-mail</h4>
            <form @submit.prevent="validate">
              <input class="Input_text" type="email" placeholder="Mon adresse e-mail" v-model="email" required/>
              <div class="PanelEmail_mentions">
                <label class="Input_checkbox">
                  <div v-html="data.checkbox_1"></div>
                  <input type="checkbox" v-model="recap" required>
                  <span></span>
                </label>

                <label class="Input_checkbox">
                  <div v-html="data.checkbox_2"></div>
                  <input type="checkbox" v-model="newsletter">
                  <span></span>
                </label>

                <input type="submit" class="Cta Cta_blue" value="Je valide" ref="submit" :disabled="email.length <= 2 || !recap"/>
                <p><small>{{ message }}</small></p>
              </div>
            </form>
          </div>

        </transition>
      </div>
    </transition>
    
  </aside>
</template>

<script>
  import panel from '@/mixins/panel'
  import { mapActions, mapState } from 'vuex' 

  import Media from '@/components/Media'

  export default {
    name: "PanelEmail",
    mixins: [ panel ],
    components: {
      Media
    },
    data() {
      return {
        data: null,
        email: '',
        newsletter: false,
        recap: false,
        message: null,
        emailOk: false
      }
    },
    computed: {
      ...mapState([
        'user'
      ])
    },
    methods: {
      fetchData()
      {
        this.$api.getPage('qualiscore-email-panel')
        .then(response => {
          this.data = response.data
        })
      },
      validate()
      {
        this.$gtm.trackEvent({ category: 'button_email_cta', action: 'click', label: 'popin_email_jevalide' })

        this.$refs.submit.disabled = true
        this.$api.sendQualiscore(this.user.token, { 
          email: this.email,
          accept: this.recap,
          optin: this.newsletter
        })
        .then( response => {
          this.emailOk = true
          this.message = response.data.message
        })
      }
    },
    created()
    {
      this.fetchData()
    }
  }
</script>

<style lang="stylus" scoped>
.PanelEmail

  .Panel_content

    padding-top 80px
    margin auto 0px

  .Panel_wrapper

    display flex
    flex-direction column
    align-items center
    // justify-content: center
    padding-top 0px

    @media $small

      display block

  img

    max-width 185px
    display block
    margin auto
    margin-bottom 40px

  &_mentions

    margin-top 40px
    font-size: 14px;
    color: $blue
    text-align left
    line-height: 22px;

    @media $small

      margin-top 20px
      font-size: 12px;
      line-height: 18px;

    a

      text-decoration underline

  .Cta

    width 100%

.ie

  .PanelEmail

    &_mentions

      width 300px
  
</style>